(function ($) {
    class W4D_Carousel {
        constructor() {
            this.initSelectors();
            this.init();
        }

        initSelectors() {
            this.$glides = $('.glide');
            this.heroGlideClass = 'js-hero-carousel';
            this.offeringGlideClass = 'js-offering-carousel';
            this.cardsCarouselClass = 'js-cards-carousel';
            this.testimonialsCarouselClass = 'js-testimonials-carousel';
            this.logoSliderClass = 'js-w4d-logo-slider';
            this.featuredProductsCarouselClass = 'js-products-carousel';
        }

        init() {
            this.$glides.each((index, element) => {
                const $element = $(element);
                const offerClass = $element.attr('class').split(' ')
                    .find(className => className.startsWith(this.offeringGlideClass));
                const cardsClass = $element.attr('class').split(' ')
                    .find(className => className.startsWith(this.cardsCarouselClass));
                const heroClass = $element.attr('class').split(' ')
                    .find(className => className.startsWith(this.heroGlideClass));
                const logoClass = $element.attr('class').split(' ')
                .find(className => className.startsWith(this.logoSliderClass));
                const productsClass = $element.attr('class').split(' ')
                    .find(className => className.startsWith(this.featuredProductsCarouselClass));
                const testimonialClass = $element.attr('class').split(' ')
                    .find(classname => classname.startsWith(this.testimonialsCarouselClass));

                if (heroClass) {
                    this.init_hero_carousel(heroClass);
                } else if (offerClass) {
                    this.init_offering_carousel(offerClass);
                } else if (cardsClass) {
                    this.init_cards_carousel(cardsClass);
                } else if (testimonialClass) {
                    this.init_testimonials_carousel(testimonialClass);
                } else if (logoClass) {
                    this.init_w4d_logo_slider(logoClass);
                } else if (productsClass) {
                    this.init_product_carousel(productsClass);
                }
            });
        }

        init_hero_carousel(jsGlide) {
            const $glideElement = $(`.${jsGlide}`);
            const dataOptions = $glideElement.data('glide-options');

            // Osnovne opcije s dodanim custom opcijama
            const options = {
                type: 'slider',
                gap: 0,
                ...(dataOptions || {})
            };

            const glide = new Glide(`.${jsGlide}`, options);
            glide.mount();
        }

        init_offering_carousel(jsGlide) {
            const $glideEl = $(`.${jsGlide}`);
            const $slides = $glideEl.find('.glide__slide');

            const options = {
                type: 'slider', // uvijek slider nikad carousel
                perView: 5,
                gap: 25,
                bound: true,
                rewind: false,
                breakpoints: {
                    768: {
                        perView: 2,
                        gap: 12
                    },
                    992: {
                        perView: 3,
                    },
                    1200: {
                        perView: 4,
                    },
                    1400: {
                        perView: 5,
                    }
                }
            };

            const glide = new Glide(`.${jsGlide}`, options);
            glide.mount();

            // Log the current breakpoint and perView value
            const logBreakpoint = () => {
                const width = window.innerWidth;
                let currentBreakpoint = 'default';
                let currentPerView = options.perView;

                for (const [breakpoint, settings] of Object.entries(options.breakpoints)) {
                    if (width <= breakpoint) {
                        currentBreakpoint = breakpoint;
                        currentPerView = settings.perView;
                        break;
                    }
                }

                return currentPerView;
            };

            // Log the initial breakpoint and perView value
            let currentPerView = logBreakpoint();

            // Perform the initial check
            this.checkAndHideArrows($glideEl, $slides, currentPerView);

            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    currentPerView = logBreakpoint();
                    glide.update();
                    this.checkAndHideArrows($glideEl, $slides, currentPerView);
                }, 200);
            });

            // Perform the check after the Glide instance has been initialized
            glide.on('mount.after', () => {
                currentPerView = glide.settings.perView;
                this.checkAndHideArrows($glideEl, $slides, currentPerView);
            });
        }

        init_cards_carousel(jsGlide) {
            const $glideElement = $(`.${jsGlide}`);
            const dataOptions = $glideElement.data('glide-options'); 

            // Osnovne opcije s dodanim custom opcijama
            const options = {
                type: 'slider',
                gap: 25,
                perView: 3,
                bound: true,
                rewind: false,
                breakpoints: {
                    768: {
                        perView: 1,
                        gap: 13,
                    },
                    992: {
                        perView: 1,
                        peek: 40,

                    },
                    1400: {
                        perView: 2,
                        peek: 80,
                    },
                    1600: {
                        perView: 3,
                        peek: 80,
                    },

                },
                ...(dataOptions || {})
            };

            const glide = new Glide(`.${jsGlide}`, options);
            glide.mount();
        }
       

        init_testimonials_carousel(jsGlide) {
            const $glideElement = $(`.${jsGlide}`);
            const dataOptions = $glideElement.data('glide-options'); 
        
            const options = {
                type: 'slider',
                gap: 8,
                perView: 3,
                bound: true,
                rewind: false,
                breakpoints: {
                    480: { 
                        perView: 1,
                    },
                    768: {
                        perView: 2,
                        gap: 13,
                    },
                    992: {
                        perView: 2,
                    },
                    1400: {
                        perView: 3,
                    },
                    1600: {
                        perView: 3,
                    },
                },
                ...(dataOptions || {})
            };
        
            const glide = new Glide(`.${jsGlide}`, options);
            glide.mount();
        }
        init_w4d_logo_slider(jsGlide) {
            const $glideElement = $(`.${jsGlide}`);
            const dataOptions = $glideElement.data('glide-options'); 
            const options = {
                    perView: 6,
                    gap: 20,
                    hoverpause: true,
                    breakpoints: {
                        1440: { perView: 5 },
                        1200: { perView: 4 },
                        1024: { perView: 3 },
                        768: { perView: 2 },
                        480: { perView: 2 }
                    },
                ...(dataOptions || {})
            };

            const glide = new Glide(`.${jsGlide}`, options);
            glide.mount();
        }

        init_product_carousel(jsGlide) {
            const $glideEl = $(`.${jsGlide}`);
            const $slides = $glideEl.find('.glide__slide');

            const options = {
                type: 'slider', // uvijek slider nikad carousel
                perView: 4,
                gap: 25,
                bound: true,
                rewind: false,
                breakpoints: {
                    768: {
                        perView: 2,
                    },
                    992: {
                        perView: 2,
                        peek: 135,
                    },
                    1200: {
                        perView: 3,
                        peek:123,
                    },
                    1400: {
                       perView: 4,
                       peek: 130,
                    }
                }
            };

            const glide = new Glide(`.${jsGlide}`, options);
            glide.mount();

            // Log the current breakpoint and perView value
            const logBreakpoint = () => {
                const width = window.innerWidth;
                let currentBreakpoint = 'default';
                let currentPerView = options.perView;

                for (const [breakpoint, settings] of Object.entries(options.breakpoints)) {
                    if (width <= breakpoint) {
                        currentBreakpoint = breakpoint;
                        currentPerView = settings.perView;
                        break;
                    }
                }

                return currentPerView;
            };

            // Log the initial breakpoint and perView value
            let currentPerView = logBreakpoint();

            // Perform the initial check
            this.checkAndHideArrows($glideEl, $slides, currentPerView);

            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    currentPerView = logBreakpoint();
                    glide.update();
                    this.checkAndHideArrows($glideEl, $slides, currentPerView);
                }, 200);
            });

            // Perform the check after the Glide instance has been initialized
            glide.on('mount.after', () => {
                currentPerView = glide.settings.perView;
                this.checkAndHideArrows($glideEl, $slides, currentPerView);
            });
        }
        

        checkAndHideArrows($glideEl, $slides, currentPerView) {
        const $controls = $glideEl.find('[data-glide-el="controls"]');

        if ($slides.length <= currentPerView) {
            $controls.hide();
            $glideEl.find('.glide__track').addClass('glide__track--centered');
        } else {
            $controls.show();
            $glideEl.find('.glide__track').removeClass('glide__track--centered');
        }
        }
    }

    $(document).ready(function () {
        window.W4D_Carousel = new W4D_Carousel();
    });
})(jQuery);


